<template>
  <b-modal v-model="isActive" class="aimee-conversation-modal">
    <ld-modal-content :title="'Conversation'"
                      :subtitle="formatSubtitle(conversation)">
      <aimee-chat-messages
        :messages="parsedMessages"
        :loading="loading"
        :participant="conversation?.meeting?.participant"
      />
    </ld-modal-content>
  </b-modal>
</template>

<script>
import to from "@/lib/to"
import { parseTranscript } from "@/lib/AimeeUtils"
import LdModalContent from "@/components/LdModalContent.vue"
import AimeeChatMessages from "@/components/aimee/AimeeChatMessages.vue"

export default {
  name: "AimeeConversationModal",
  components: { LdModalContent, AimeeChatMessages },
  props: {
    value: Boolean,
    conversationId: [String, Number]
  },
  data() {
    return {
      conversation: null,
      parsedMessages: [],
      loading: false
    }
  },
  computed: {
    isActive: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    async conversationId(newId) {
      if (newId) {
        await this.loadConversation()
      }
    },
    async isActive(newVal) {
      if (newVal && this.conversationId) {
        await this.loadConversation()
      }
    }
  },
  methods: {
    async loadConversation() {
      if (!this.conversationId) return

      this.loading = true
      this.conversation = null
      this.parsedMessages = []

      const [err, response] = await to(this.$http.get(`/aimee_conversations/${this.conversationId}`, { skipLoading: true }))

      if (!err) {
        this.conversation = response.data
        this.parsedMessages = parseTranscript(response.data.transcript)
      }

      this.loading = false
    },
    formatSubtitle(conversation) {
      if (!conversation) return ''
      
      const parts = []
      
      if (conversation.created_at) {
        parts.push(this.$helpers.formatDate(conversation.created_at))
      }
      if (conversation.patient_monitor?.patient?.display_name) {
        parts.push(this.$helpers.mask('patient_name', conversation.patient_monitor.patient.display_name))
      }
      if (conversation.patient_monitor?.room?.name) {
        parts.push(`Room ${conversation.patient_monitor.room.name}`)
      }
      if (conversation.patient_monitor?.division?.name) {
        parts.push(conversation.patient_monitor.division.name)
      }
      
      return parts.join(' • ')
    }
  }
}
</script>

<style lang="scss">
.aimee-conversation-modal {
  .ld-modal__content {
    overflow-y: visible
  }

  .chat-container {
    max-height: min(500px, calc(100vh - 250px));
  }
}
</style>
